module.exports = __webpack_public_path__ + "c65ef5cfd2a90261e4b243e4b0f55b3a.MP3";